import { Palette } from '@/themes/themeOverrides/Palette';

export const getDeviceStateColor = stateId => {
    const grayColors = {
        backgroundColor: Palette.gray.gray400,
        outline: `2px solid ${Palette.gray.gray500}`,
    };
    const orangeColors = {
        backgroundColor: Palette.yellow.yellow700,
        outline: `2px solid ${Palette.yellow.yellow800}`,
    };
    const greenColors = {
        backgroundColor: Palette.green.green300,
        outline: `2px solid ${Palette.green.green600}`,
    };
    const stateColorConfig = {
        online: greenColors,
        outOfService: grayColors,
        offline: grayColors,
        binFull: orangeColors,
        codeError: orangeColors,
        permanentError: {
            backgroundColor: Palette.red.red400,
            outline: `2px solid ${Palette.red.red800}`,
        },
    };
    return stateColorConfig[stateId] || grayColors;
};
